import { Building2 } from 'lucide-react';

// Imported from the module, not the `common` barrel: CounterpartyPicker renders
// this row and otherwise pulls in no shared barrel, and the barrel drags the API
// client + i18n bootstrap into every consumer's module graph.
import { IntercompanyOptionMarker } from '../../../../shared/components/common/IntercompanyOptionMarker';

export interface OrganizationOptionRowProps {
  /** Organization name shown as the row's identity. */
  name: string;
  /** Domain, rendered as the trailing muted token when present. */
  domain?: string | null;
  /**
   * The org's `linked_company_id` — set means it is one of the tenant's own
   * legal entities.
   */
  linkedCompanyId?: string | null;
  /**
   * Picker-level multi-company gate, resolved once per picker instance with
   * `useIntercompanyMarkerGate()`.
   */
  showIntercompanyMarker: boolean;
}

/**
 * The standard organization option row shared by `OrganizationPicker` (through
 * `EntityPickerBase`'s `renderItem`) and `CounterpartyPicker` (which hand-rolls
 * its `CommandItem`s and so cannot use that seam). Both rendered the same
 * icon + name + muted domain markup; the intercompany marker gave them a second
 * reason to agree, so the markup lives here once.
 */
export function OrganizationOptionRow({
  name,
  domain,
  linkedCompanyId,
  showIntercompanyMarker,
}: OrganizationOptionRowProps) {
  return (
    <>
      <Building2 className="me-1.5 h-4 w-4 text-muted-foreground shrink-0" />
      <span className="truncate">{name}</span>
      <IntercompanyOptionMarker
        linkedCompanyId={linkedCompanyId}
        enabled={showIntercompanyMarker}
      />
      {domain && (
        <span className="ms-1 text-xs text-muted-foreground shrink-0">{domain}</span>
      )}
    </>
  );
}
